import '../styles/main.scss'
import '@/lib/select.js'
import lazim from 'lazim'
import app from '@/app.js'
// import router from '@/router.js'
import { fetchCart, addAllToCart } from '@/lib/cart.js'

/**
 * store binding fn
 */
const images = lazim()

/**
 * bind on page load
 */
images()

document.addEventListener('shopify:section:load', () => {
  images();
})

// router.on('after', () => {
//   app.unmount()
//   app.mount()

//   /**
//    * bind new images
//    */
//   images()

//   // reload StoreRocket widget
//   initStoreRocket();
// })

function initStoreRocket() {
  if (document.querySelector('.storerocket-map')) {
    var config = {
      selector: ".storerocket-map",
      account: "2BrJq2z8qE",
    };

    StoreRocket.init(config);
  }
}
initStoreRocket();


/**
 * load any data that your site needs on fist load
 */
Promise.all([
  fetchCart()
]).then(([ cart ]) => {

  if (cart.item_count == 0) {
    cart.item_count = ''
  }
  
  /**
   * add the cart data to the picoapp instance
   */
  app.hydrate({ cart })

  /**
   * mount any components defined on the page
   */
  app.mount()
})


app.on('productRecommendationsLoaded', () => {
  images();
});

/**
 * Add scroll direction and scrolled classes
 */
let lastScrollTop = 0;
let scrollBufferDown = 1;
let scrollBufferUp = 10;
let headerHeight = 10 * parseFloat(getComputedStyle(document.documentElement).fontSize);
let checkScrolling = function () {
  let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
  let html = document.documentElement;
  if ( currentScroll > lastScrollTop + scrollBufferDown ) {
    html.classList.add('scrolling-down');
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  } else if ( currentScroll < lastScrollTop - scrollBufferUp ) {
    html.classList.remove('scrolling-down');
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }

  if (currentScroll > scrollBufferDown) {
    html.classList.add('is-scrolled');
  } else {
    html.classList.remove('is-scrolled');
  }

  if (currentScroll > headerHeight) {
    html.classList.add('sticky-menu-visible');
  } else {
    html.classList.remove('sticky-menu-visible');
  }

  if (currentScroll > headerHeight + 50) {
    html.classList.add('sticky-menu-active');
  } else {
    html.classList.remove('sticky-menu-active');
  }

};
window.addEventListener('scroll', checkScrolling);

/**
 * Add --vh CSS variable (use instead of 100vh in mobile Safari)
 */
let updateCSSvh = function() {
  var height = ( window.innerHeight / 100 );
  document.documentElement.style.setProperty( '--vh', height + 'px' );
}
updateCSSvh();
window.addEventListener('resize', updateCSSvh);



// Old product URL redirects
const pathname = window.location.pathname;
if (pathname.indexOf('/products/cn/') > -1 
  || pathname.indexOf('/products/p/') > -1 ) {

    const redirectURL = pathname.split('/').slice(0,4).join('/');;

    if (redirectURL != pathname) {
      window.location = redirectURL;
    }

}